import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';

import { FormikSelectOption, QueryFilters, QuerySorting } from 'components';
import { OrdersTab } from 'enums';
import { useUser } from 'hooks';
import { FilterDefinition } from 'types';

import { ExportPayoutOrders } from '../ExportOrders';

type Props = {
  tab: OrdersTab;
  queryResult: any;
  sortingFields: FormikSelectOption[];
  filtersDefinitions: FilterDefinition[];
  /** Sections without a data-service export route (e.g. the manual queue) opt out. */
  hideExport?: boolean;
};

export const OrdersActions: React.FC<Props> = ({
  tab,
  queryResult,
  filtersDefinitions,
  sortingFields,
  hideExport,
}) => {
  const { isAdmin, isTechOperator, isTrader, isMerchant, isMerchantOperator } =
    useUser();
  const exportEnabled = useMemo(() => {
    if (hideExport || isEmpty(queryResult.data?.items)) {
      return false;
    }
    return (
      isAdmin ||
      isTechOperator ||
      isTrader ||
      ((isMerchant || isMerchantOperator) && tab === OrdersTab.All)
    );
  }, [
    hideExport,
    isAdmin,
    isTechOperator,
    isTrader,
    isMerchant,
    isMerchantOperator,
    queryResult,
    tab,
  ]);

  return (
    <div className="tw-flex tw-items-center tw-justify-end">
      <div className="tw-flex-1">
        <QueryFilters filtersDefinitions={filtersDefinitions} />
      </div>
      {!isEmpty(sortingFields) && (
        <QuerySorting sortingFields={sortingFields} />
      )}
      {exportEnabled && <ExportPayoutOrders tab={tab} />}
    </div>
  );
};
